<template>
	<div class="row margin-tb-150">

		<article class="wrap--sm">

			<stepper></stepper>

			<transition name="fade" mode="out-in">
				<router-view dusk="currentView"></router-view>
			</transition>
		</article>

	</div>
</template>

<script>
	import Stepper from './partials/stepper.vue';
	import {mapGetters} from 'vuex';
    export default {
        name: "orderManager",
		components:{
            Stepper
		},
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if(!vm.$store.getters.selectionsValid || !vm.$store.getters.completedProduct){
                    vm.$router.replace({name:'product'});
				}
            })
        },
    }
</script>

<style scoped>

</style>